import React, { createContext, useContext, useReducer } from 'react';

const ApplicationContext = createContext();

const initialState = {
  currentStep: 1,
  totalSteps: 4,
  formData: {
    // Personal Information
    title: '',
    firstName: '',
    middleName: '',
    lastName: '',
    dateOfBirth: '',
    placeOfBirth: '',
    nationality: '',
    maritalStatus: '',
    gender: '',
    mothersMaidenName: '',
    
    // Contact Information
    residentialAddress: '',
    postalAddress: '',
    city: '',
    region: '',
    country: 'Ghana',
    phoneNumber: '',
    alternatePhone: '',
    email: '',
    
    // Employment Information
    occupation: '',
    employer: '',
    workAddress: '',
    monthlyIncome: '',
    sourceOfIncome: '',
    
    // Account Information
    accountType: 'savings',
    initialDeposit: '',
    preferredBranch: '',
    
    // Identification
    idType: '',
    idNumber: '',
    idExpiryDate: '',
    
    // Next of Kin
    nextOfKinName: '',
    nextOfKinRelationship: '',
    nextOfKinPhone: '',
    nextOfKinAddress: '',
    
    // Agreement
    termsAccepted: false,
    marketingConsent: false,
  },
  errors: {},
  isSubmitting: false,
};

function applicationReducer(state, action) {
  switch (action.type) {
    case 'UPDATE_FORM_DATA':
      return {
        ...state,
        formData: { ...state.formData, ...action.payload },
      };
    case 'SET_CURRENT_STEP':
      return {
        ...state,
        currentStep: action.payload,
      };
    case 'SET_ERRORS':
      return {
        ...state,
        errors: action.payload,
      };
    case 'SET_SUBMITTING':
      return {
        ...state,
        isSubmitting: action.payload,
      };
    case 'RESET_FORM':
      return initialState;
    default:
      return state;
  }
}

export function ApplicationProvider({ children }) {
  const [state, dispatch] = useReducer(applicationReducer, initialState);

  return (
    <ApplicationContext.Provider value={{ state, dispatch }}>
      {children}
    </ApplicationContext.Provider>
  );
}

export function useApplication() {
  const context = useContext(ApplicationContext);
  if (!context) {
    throw new Error('useApplication must be used within an ApplicationProvider');
  }
  return context;
}